/**
 * Created by Ning Jiang on 2024-08-27.
 */
import {ElGordosRevengeSymbol} from "./ElGordosRevengeSymbol";
import {ElGordosRevengeSymbolState} from "./ElGordosRevengeSymbolConfig";
import {TimelineLite, TweenLite} from "gsap";
import {ElGordosRevengeLayers, Layers} from "../view/ElGordosRevengeLayers";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";

export class EGRBonusSymbol extends ElGordosRevengeSymbol {

    private _reelPosition:PIXI.Point;

    constructor(reelId:number, initState:ElGordosRevengeSymbolState) {
        super("BN", reelId, initState);
    }

    protected getCharacterAssetName():string {
        return "BN";
    }

    public playLanding(init:boolean = false):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(0, "landing", false);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.BONUS_LAND});
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(0, "loop", true);
        }, `+=${this._deadCharacter.spineData.findAnimation("landing").duration}`);
        return tl;
    }

    public onReelStop():void {
        this._reelPosition = new PIXI.Point(this.position.x, this.position.y);
        const globalPosition = this.getGlobalCenterPosition();
        this.position.set(globalPosition.x, globalPosition.y);
        ElGordosRevengeLayers.getLayer(Layers.NEAR_WIN)!.addChild(this);
    }

    public playCollect():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(0, "Dagger_out", false);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.BONUS_ACTIVATE});
            TweenLite.to(this, this._deadCharacter.spineData.findAnimation("Dagger_out").duration, {
                onComplete : () => {
                    this.playAfterCollect(false);
                }
            });
        });
        tl.add(() => {
            // this._deadCharacter.state.setAnimation(0, "Dagger_outLoop", true);
        }, 0.8);

        return tl;
    }

    public playAfterCollect(init:boolean):void {
        this.createDeadContainer();
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(0, "Dagger_outDead", false);
        if(!init) {
            const tl = new TimelineLite();
            tl.add(() => {
                this.position.set(this._reelPosition.x, this._reelPosition.y);
                ElGordosRevenge.reels[this.reelId].reelView.addSymbol(this);
            }, 0.2);
        }
    }

    protected playKill():TimelineLite {
        const tl = new TimelineLite();
        tl.add(TweenLite.to(this, 0.1, {}));
        return tl;
    }
}